var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 209.486 280.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-bdae17eb-6a39-4b63-b6d4-9d4389d831de {\n        stroke: #fbb03b;\n      }\n\n      .uuid-bdae17eb-6a39-4b63-b6d4-9d4389d831de, .uuid-eae2563f-424f-480c-aa62-76b8aa9c85c9 {\n        stroke-width: 3px;\n      }\n\n      .uuid-bdae17eb-6a39-4b63-b6d4-9d4389d831de, .uuid-eae2563f-424f-480c-aa62-76b8aa9c85c9, .uuid-b001da5c-daed-4a94-8264-d38d07fa61ef {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .uuid-eae2563f-424f-480c-aa62-76b8aa9c85c9 {\n        stroke: #4d4d4d;\n      }\n\n      .uuid-02c50ef8-3dc1-4d72-820a-3e8dd598ceff {\n        fill: url(#uuid-04dd8cf7-184a-4da6-ad8d-2df2ea17d04c);\n        opacity: .1;\n      }\n\n      .uuid-02c50ef8-3dc1-4d72-820a-3e8dd598ceff, .uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5, .uuid-43d62160-2fdb-4958-9a48-f41e52dcc926, .uuid-40db204e-ea57-4714-9c66-d3e09530a645, .uuid-71fbc289-daa5-403e-b1d8-6d4f316f8788 {\n        isolation: isolate;\n      }\n\n      .uuid-99fe3349-183b-4506-bcfb-4b2cd852dc28 {\n        fill: #f7f7f7;\n      }\n\n      .uuid-0593d231-14ad-4115-8e90-290ae6fd9a54 {\n        fill: #0049b0;\n      }\n\n      .uuid-7430ef9f-229e-49e4-96ce-85e3ed852d9a {\n        fill: #0065ff;\n      }\n\n      .uuid-63c3a413-4bed-4b7f-9240-66be4bb90d1d, .uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5 {\n        fill: #fff;\n      }\n\n      .uuid-7e4baf3a-24a6-4874-b54f-94cf71a822cc {\n        fill: #feefd3;\n      }\n\n      .uuid-40a6fe64-1d8d-45a1-ad99-56ae671b0338 {\n        fill: #fcb123;\n      }\n\n      .uuid-c0ef5309-25b1-4db9-a368-4a555c508f34 {\n        fill: #dfe1e5;\n      }\n\n      .uuid-ee6929c4-6ddf-45ea-a87d-cb167b8bf2c8 {\n        fill: #253858;\n      }\n\n      .uuid-22cac48a-0101-48e1-afc1-2f92eed9cd2d {\n        fill: #172b4d;\n      }\n\n      .uuid-ccd3fa68-7744-470d-bcac-969e19cd8c6c {\n        fill: #42526e;\n      }\n\n      .uuid-7ce57af2-6f25-44a7-9358-4d3bffd25bd8 {\n        fill: #72594b;\n      }\n\n      .uuid-d3d81237-5731-4f29-b2f8-20bf015fdc88 {\n        fill: #543e36;\n      }\n\n      .uuid-79ba8397-eb20-4a3c-8652-6a11c5a1627b, .uuid-40db204e-ea57-4714-9c66-d3e09530a645 {\n        fill: #4c9aff;\n      }\n\n      .uuid-0c55e8ed-147a-46d1-acbc-93c81ee24530 {\n        fill: #2684ff;\n      }\n\n      .uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5, .uuid-43d62160-2fdb-4958-9a48-f41e52dcc926, .uuid-40db204e-ea57-4714-9c66-d3e09530a645 {\n        opacity: .2;\n      }\n\n      .uuid-43d62160-2fdb-4958-9a48-f41e52dcc926 {\n        fill: #e6e9f8;\n      }\n\n      .uuid-71fbc289-daa5-403e-b1d8-6d4f316f8788 {\n        opacity: .1;\n      }\n\n      .uuid-abdd89dc-19cd-4715-886d-2403f1987fd5 {\n        fill: url(#uuid-bb40b56a-66b9-4815-9179-628283bf0d6c);\n      }\n\n      .uuid-b001da5c-daed-4a94-8264-d38d07fa61ef {\n        stroke: #42526e;\n        stroke-width: 1.47px;\n      }\n\n      .uuid-278264d9-d4ed-47a3-970c-3dda3441b543 {\n        fill: url(#uuid-93a18587-8db9-46f9-9d00-6807a98b176a);\n      }\n\n      .uuid-3bafa2f3-fcc7-43f6-b576-41b3bf6d660c {\n        fill: url(#uuid-285c487b-9aa2-4cb5-978a-bfbab6236859);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "uuid-93a18587-8db9-46f9-9d00-6807a98b176a",
    cx: 112.842,
    cy: 164.473,
    fx: 112.842,
    fy: 164.473,
    r: 96.644,
    gradientTransform: "translate(0 261.117) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#ffe380",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#ffe482",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#ffe58a",
    stopOpacity: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#ffe996",
    stopOpacity: 0.326
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#ffeea8",
    stopOpacity: 0.379
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0b2",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-285c487b-9aa2-4cb5-978a-bfbab6236859",
    x1: 3780.203,
    y1: -2738.72,
    x2: 3780.203,
    y2: -2857.384,
    gradientTransform: "translate(227.905 -4549.46) rotate(59.781) scale(.955 -.891) skewX(-8.043)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe380"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-04dd8cf7-184a-4da6-ad8d-2df2ea17d04c",
    x1: -24.497,
    y1: 924.601,
    x2: 46.393,
    y2: 924.601,
    gradientTransform: "translate(83.891 -651) rotate(-180) scale(.851 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#091e42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#091e42",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#091e42",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#091e42",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#091e42",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#091e42",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-bb40b56a-66b9-4815-9179-628283bf0d6c",
    x1: -1128.75,
    y1: 858.667,
    x2: -1097.802,
    y2: 858.667,
    gradientTransform: "translate(1037.496 -651) scale(.851 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0065ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049b0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-2934b94c-cdb6-429f-a508-67deb908941b",
    "data-name": "Layer 5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-3f0e35de-93f5-486b-bfb2-bf4d32568b3e",
    "data-name": "Layer 1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-2b16d997-ebdb-4d54-a50c-b53905abde8b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-b1361b83-4393-4415-891d-899424265853",
    "data-name": "Layer 7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-56764428-65c2-4bec-aff2-0b755e4b92a9",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-278264d9-d4ed-47a3-970c-3dda3441b543",
    cx: 112.842,
    cy: 96.644,
    r: 96.644
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c0ef5309-25b1-4db9-a368-4a555c508f34",
    x: 2.654,
    y: 26.615,
    width: 158.217,
    height: 217.556,
    rx: 17.723,
    ry: 17.723
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-79ba8397-eb20-4a3c-8652-6a11c5a1627b",
    y: 28.667,
    width: 158.217,
    height: 217.556,
    rx: 17.723,
    ry: 17.723
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-71fbc289-daa5-403e-b1d8-6d4f316f8788",
    d: "M112.527,67.226L31.418,48.254c-2.778-.634-5.548,1.088-6.208,3.86l-9.167,39.183-3.184,13.628c-.629,2.774,1.086,5.539,3.851,6.208l81.109,18.934c2.774,.629,5.539-1.086,6.208-3.851l1.831-7.852,10.519-44.959c.617-2.765-1.096-5.515-3.851-6.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5",
    x: 21.5,
    y: 132.876,
    width: 114.359,
    height: 10.472
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-c0ef5309-25b1-4db9-a368-4a555c508f34",
    x: 32.885,
    y: 40.903,
    width: 93.629,
    height: 64.561,
    rx: 5.166,
    ry: 5.166
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-40db204e-ea57-4714-9c66-d3e09530a645",
    d: "M126.513,99.082v4.712c-.021,1.66-2.323,3.002-5.166,3.011H38.041c-2.845-.006-5.15-1.35-5.166-3.011v-8.178l28.289-10.329,20.86,8.881,18.314-6.193,26.175,11.108Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-43d62160-2fdb-4958-9a48-f41e52dcc926",
    cx: 106.056,
    cy: 60.473,
    r: 8.688
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5",
    x: 21.592,
    y: 149.056,
    width: 114.267,
    height: 10.472
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5",
    x: 21.592,
    y: 165.166,
    width: 114.267,
    height: 10.472
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5",
    x: 21.592,
    y: 181.276,
    width: 114.267,
    height: 10.472
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5",
    x: 21.592,
    y: 196.715,
    width: 114.267,
    height: 10.472
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-57e11907-fdd7-40da-ae77-e73c53b02ea5",
    x: 21.592,
    y: 212.154,
    width: 114.267,
    height: 10.472
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-eae2563f-424f-480c-aa62-76b8aa9c85c9",
    points: "7.985 201.087 10.879 204.77 17.719 197.051"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-bdae17eb-6a39-4b63-b6d4-9d4389d831de",
    points: "8.569 201.277 11.462 204.96 18.302 197.241"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-bdae17eb-6a39-4b63-b6d4-9d4389d831de",
    points: "9.24 153.618 12.134 157.301 18.974 149.582"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "uuid-238c74e9-4c1d-4202-b43e-c1e3ecfe7f5e",
    "data-name": " Clipping Path 13",
    className: "uuid-7e4baf3a-24a6-4874-b54f-94cf71a822cc",
    points: "19.628 199.856 33.871 175.61 44.045 193.006 19.628 199.856"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ee6929c4-6ddf-45ea-a87d-cb167b8bf2c8",
    d: "M117.111,108.526l10.174,17.396h0l7.399-5.98c4.045-3.334,5.073-9.862,2.312-14.678h0c-2.836-4.755-8.389-5.963-12.486-2.718l-7.399,5.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-3bafa2f3-fcc7-43f6-b576-41b3bf6d660c",
    points: "127.438 125.625 117.301 108.221 34.013 175.262 44.15 192.667 127.438 125.625"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-ccd3fa68-7744-470d-bcac-969e19cd8c6c",
    points: "28.322 197.464 19.628 199.856 24.715 191.267 28.322 197.464"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-40a6fe64-1d8d-45a1-ad99-56ae671b0338",
    points: "122.357 116.894 117.289 108.192 34 175.233 39.069 183.935 122.357 116.894"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-b001da5c-daed-4a94-8264-d38d07fa61ef",
    x1: 125.065,
    y1: 102.111,
    x2: 135.239,
    y2: 119.507
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-b001da5c-daed-4a94-8264-d38d07fa61ef",
    x1: 122.013,
    y1: 104.612,
    x2: 132.094,
    y2: 122.008
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-02c50ef8-3dc1-4d72-820a-3e8dd598ceff",
    cx: 74.578,
    cy: 273.601,
    rx: 30.151,
    ry: 6.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-7ce57af2-6f25-44a7-9358-4d3bffd25bd8",
    d: "M83.549,136.062c.366,.56,.891,.946,1.48,1.087,.832,0,1.202-.87,2.405-2.283s3.422-2.718,3.237-3.262-.185-.217-1.295-.326-2.682-.326-3.052-.217c-.549,.134-1.059,.434-1.48,.87-.384,.44-.643,1.01-.74,1.631l-.555,2.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7ce57af2-6f25-44a7-9358-4d3bffd25bd8",
    d: "M102.417,191.404c-.237-1.349-.675-2.637-1.295-3.805l-1.48,.435-1.202,.217c-1.295,.217-3.792,.544-10.636,1.196l-1.295,2.066c-1.23,2.355-2.135,4.924-2.682,7.611-4.532,22.18-4.902,22.941-4.902,22.941-.647,4.349-1.295,8.698-1.85,13.047-1.202,8.698-2.775,25.116-3.607,33.488,.154,.587,.442,1.113,.832,1.522,.411,.345,.887,.569,1.387,.652,1.665,.326,4.717-10.438,4.717-10.438,1.786-7.115,2.872-14.448,3.237-21.854,.015-1.858-.109-3.713-.37-5.545l6.012-13.373,4.624-10.438c-.092,8.372-.092,16.744,0,25.333,0,10.329,.185,20.549,.37,30.661,.232,.263,.519,.451,.832,.544,.523,.131,1.066,.094,1.572-.109,.777-.296,1.478-.82,2.035-1.522,1.047-6.28,1.727-12.638,2.035-19.027,.555-9.024-.185-8.372,.277-15.657,.647-11.09,3.145-26.855,2.497-32.074-.185-.761-.74-4.023-1.11-5.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-22cac48a-0101-48e1-afc1-2f92eed9cd2d",
    d: "M94.74,146.391c-.462-.979-1.11-2.283-.647-3.044s1.202-.109,3.422,0,3.422-.544,4.994,0c1.263,.441,2.368,1.358,3.145,2.609,1.48,2.501,.832,5.654,.647,6.632-.69,2.538-2.135,4.7-4.069,6.089l-1.757,1.196-4.809-9.677-.925-3.805Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d3d81237-5731-4f29-b2f8-20bf015fdc88",
    d: "M100.289,163.352h-6.474c.997-2.707,1.224-5.719,.647-8.589l3.977-.217c.075,.368,.168,.731,.277,1.087,.081,.45,.205,.888,.37,1.305,.465,.552,1.097,.865,1.757,.87l-.555,5.545Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0593d231-14ad-4115-8e90-290ae6fd9a54",
    d: "M101.677,229.349v-.435c.277-4.458,.832-9.568,1.387-14.569,.832-7.393,1.572-14.461,1.11-17.614-.092-.87-.74-4.24-1.017-6.089l-.555-1.848c-.199-.763-.479-1.493-.832-2.175l-.277-.544-.555,.217-1.387,.326-1.017,.217h-.185c-1.202,.217-3.7,.544-10.544,1.196h-.37l-.185,.326c-.462,.699-.894,1.425-1.295,2.175-1.283,2.413-2.221,5.058-2.775,7.828-4.162,19.897-4.809,22.615-4.902,22.941h-.092c-.277,1.848-.462,3.697-.74,5.545,2.035,1.957,5.087,2.501,8.139,2.283,1.387-3.262,2.867-6.524,4.347-9.785l3.145-7.285c0,5.436,0,10.764,.092,16.092,2.675,1.37,5.634,1.786,8.509,1.196Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-abdd89dc-19cd-4715-886d-2403f1987fd5",
    d: "M101.399,202.494c1.052-1.516,1.782-3.305,2.127-5.219,.245-2.218,.119-4.471-.37-6.632l-.555-1.848c-.199-.763-.479-1.493-.832-2.175l-.277-.544-.555,.217-1.387,.326-1.017,.217h-.185c-1.202,.217-3.7,.544-10.544,1.196h-.37l-.185,.326c-.462,.699-.894,1.425-1.295,2.175-2.405,4.458-3.237,10.22-4.347,15.222-1.11,5.001-1.665,7.611-2.405,11.416-.277,.87-2.405,9.133-1.757,9.785s5.087,2.501,8.139,2.283c1.387-3.262,2.867-6.524,4.347-9.785s3.237-7.72,6.012-10.873c1.951-1.859,3.776-3.895,5.457-6.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7ce57af2-6f25-44a7-9358-4d3bffd25bd8",
    d: "M94.74,146.391l-.832,2.501-2.775,1.957c.185,.544,.462,.979,.647,1.413l-.277,5.001c.845,.715,1.781,1.266,2.775,1.631,.37,.217,.555,.217,3.792,.326,1.48,0,2.22,.109,2.497-.435,.363-.612,.399-1.413,.092-2.066-.185-.544-.462-.544-.74-1.087s.092-1.522-.092-2.392-.832-.761-1.757-1.848-.74-2.066-1.757-3.479c-.437-.621-.97-1.137-1.572-1.522Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0c55e8ed-147a-46d1-acbc-93c81ee24530",
    d: "M70.878,162.483c4.78,3.917,10.055,6.925,15.631,8.916,0,2.283-3.145,21.419-3.7,25.007,3.359,1.321,6.834,2.196,10.359,2.609,3.963,.547,7.979,.215,11.839-.979,.185-4.893-.555-16.744,.832-23.05,.277-1.413,.555-2.718,.925-4.023,.566-2.166-.149-4.512-1.757-5.762h-.092l-.647-.435-1.572-1.087c-3.33-1.848-9.434-2.609-9.434-2.609l-6.474-.979c-2.775-.544-5.364-1.087-7.769-1.848,1.11-3.479,2.312-6.958,3.607-10.546s2.59-7.067,3.885-10.438l-3.237-2.609c-2.035,3.805-4.162,7.937-6.289,12.504-2.127,4.567-4.254,10.112-6.104,15.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c0ef5309-25b1-4db9-a368-4a555c508f34",
    d: "M98.995,267.512h-4.994c.092-.979,.092-2.066,.185-3.153,.018-.69-.013-1.381-.092-2.066,1.591-.327,3.218-.327,4.809,0-.2,1.735-.169,3.495,.092,5.219h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c0ef5309-25b1-4db9-a368-4a555c508f34",
    d: "M77.537,271.862h-4.994c0-1.087,.832-4.24,.925-5.328l2.682-.326,2.497-.435c-.185,.979-.462,1.957-.647,3.044s-.277,2.066-.462,3.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-31ded759-d6b3-44b8-a289-7d98d4553ea4",
    "data-name": " Path 6",
    className: "uuid-ccd3fa68-7744-470d-bcac-969e19cd8c6c",
    d: "M95.018,267.078h0c-.092,.109-.37-.87-.74-1.087s0,2.175-1.665,3.805c-.58,.561-1.237,1.002-1.942,1.305-.231,.157-.372,.448-.37,.761v.652h9.619c0-1.856-.281-3.697-.832-5.436h-4.069Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-c7e107c5-13c1-41a4-a65a-c5aa95868ff7",
    "data-name": " Path 7",
    className: "uuid-ccd3fa68-7744-470d-bcac-969e19cd8c6c",
    d: "M73.56,271.427h0c-.092,.109-.37-.87-.74-1.087s-1.85,2.066-3.977,3.697c-.788,.643-1.664,1.121-2.59,1.413-.27,.054-.466,.331-.462,.652v.761h12.671c0-1.856-.281-3.697-.832-5.436h-4.069Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-63c3a413-4bed-4b7f-9240-66be4bb90d1d",
    d: "M139.3,67.588c.008-.039,.015-.079,.023-.118l.014-.079c.005-.035,.011-.069,.016-.103,.007-.043,.013-.087,.018-.13,.004-.031,.007-.063,.011-.094,.006-.05,.011-.101,.015-.15l.005-.07c.003-.046,.006-.091,.008-.138l.003-.063c.002-.066,.004-.132,.004-.198,0-.073-.002-.144-.004-.216-.002-.037-.004-.073-.006-.11-.002-.034-.003-.068-.006-.102-.004-.05-.009-.101-.014-.151-.002-.019-.003-.038-.006-.056-.007-.062-.015-.124-.024-.185l-.002-.019c-.286-1.901-1.532-3.633-3.425-4.978l-.008-.006c-1.594-1.13-3.645-1.985-5.966-2.433l-.015-.003c-.092-.017-.186-.035-.279-.052l-.028-.005c-.09-.016-.182-.031-.272-.046l-.035-.005c-.091-.014-.182-.028-.273-.042l-.034-.005c-.092-.013-.185-.025-.279-.038l-.028-.003c-.096-.013-.194-.024-.291-.035l-.013-.002c-.415-.045-.837-.078-1.264-.097h-.004c-.307-.014-.615-.022-.925-.022-7.281,0-13.204,3.861-13.204,8.608,0,2.337,1.426,4.527,4.016,6.165,.134,.085,.21,.237,.197,.395l-.253,3.179,3.786-1.799c.093-.045,.199-.054,.298-.026,1.635,.455,3.37,.685,5.16,.685,4.427,0,8.353-1.427,10.75-3.611,.013-.017,.028-.032,.044-.047,1.223-1.132,1.999-2.414,2.286-3.76l.008-.038Zm-13.156,1.747h-6.469c-.236,0-.428-.191-.428-.427s.192-.427,.428-.427h6.469c.236,0,.428,.191,.428,.427s-.192,.427-.428,.427Zm3.164-3.126h-9.632c-.236,0-.428-.191-.428-.427s.192-.427,.428-.427h9.632c.236,0,.427,.191,.427,.427s-.191,.427-.427,.427Zm3.442-3.129h-13.074c-.236,0-.428-.191-.428-.427s.192-.427,.428-.427h13.074c.236,0,.428,.191,.428,.427s-.192,.427-.428,.427Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-63c3a413-4bed-4b7f-9240-66be4bb90d1d",
    d: "M147.433,68.857c2.589-1.635,4.016-3.826,4.016-6.169,0-4.742-5.924-8.6-13.206-8.6-3.843,0-7.492,1.105-9.994,2.993,2.131,.206,4.145,.736,5.912,1.551l.018,.008c.145,.067,.288,.137,.43,.208,.027,.013,.054,.027,.08,.04,.131,.067,.262,.135,.39,.205,.031,.017,.062,.035,.094,.052,.105,.059,.209,.118,.312,.18,.033,.019,.067,.038,.099,.058,.113,.068,.224,.138,.334,.209,.041,.026,.082,.052,.122,.079l.046,.029c.073,.048,.144,.097,.215,.146h9.893c.236,0,.427,.191,.427,.427s-.191,.427-.427,.427h-8.796c.794,.698,1.434,1.462,1.905,2.271h3.447c.236,0,.427,.191,.427,.427s-.191,.427-.427,.427h-3.019c.234,.554,.393,1.125,.475,1.708h0c.01,.075,.02,.149,.028,.223l.004,.043c.006,.06,.012,.122,.016,.182,.003,.034,.004,.067,.005,.101,.002,.043,.005,.086,.007,.129,.003,.077,.004,.155,.004,.233,0,.097-.003,.194-.007,.291,0,.027-.003,.053-.004,.08-.004,.076-.01,.153-.017,.229l-.006,.066c-.021,.202-.051,.402-.09,.601l-.006,.029c-.255,1.266-.881,2.47-1.844,3.553,1.771-.004,3.489-.235,5.107-.685,.037-.011,.076-.016,.115-.016,.064,0,.127,.014,.185,.042l.186,.09,3.599,1.706-.254-3.18c-.013-.158,.063-.31,.198-.396Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-63c3a413-4bed-4b7f-9240-66be4bb90d1d",
    d: "M28.43,64.658c-.073,.055-.16,.083-.247,.083s-.174-.027-.246-.083l-18.197-13.696v17.615H27.244c.226,0,.41,.183,.41,.41s-.184,.41-.41,.41H9.74v3.357h11.14c.226,0,.41,.183,.41,.41s-.183,.41-.41,.41H9.74v2.122H46.629v-24.734l-18.199,13.696Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-63c3a413-4bed-4b7f-9240-66be4bb90d1d",
    points: "45.811 50.55 10.556 50.55 28.183 63.817 45.811 50.55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-7430ef9f-229e-49e4-96ce-85e3ed852d9a",
    d: "M178.91,105.074l-2.272-.787c-.881-.305-1.867-.03-2.442,.705-.36,.46-.746,.894-1.155,1.301-.663,.659-.824,1.671-.415,2.512l1.051,2.164c.371,.764,.049,1.692-.715,2.063l-2.813,1.366c-.764,.371-1.692,.049-2.063-.714l-1.051-2.164c-.408-.841-1.303-1.341-2.231-1.227-.573,.07-1.153,.105-1.736,.103-.933-.003-1.759,.602-2.064,1.483l-.787,2.272c-.278,.802-1.162,1.231-1.964,.954l-2.955-1.023c-.802-.278-1.231-1.162-.954-1.964l.787-2.272c.305-.881,.03-1.867-.705-2.442-.46-.36-.894-.746-1.301-1.155-.659-.663-1.671-.824-2.512-.415l-2.164,1.051c-.764,.371-1.692,.049-2.063-.715l-1.366-2.813c-.371-.764-.049-1.692,.714-2.063l2.164-1.051c.841-.408,1.341-1.303,1.227-2.231-.07-.573-.105-1.153-.103-1.736,.003-.932-.602-1.759-1.483-2.064l-2.272-.787c-.802-.278-1.231-1.162-.954-1.964l1.023-2.955c.278-.802,1.162-1.231,1.964-.954l2.272,.787c.881,.305,1.867,.03,2.442-.705,.36-.46,.746-.894,1.155-1.301,.663-.659,.824-1.671,.415-2.512l-1.051-2.164c-.371-.764-.049-1.692,.715-2.063l2.813-1.366c.764-.371,1.692-.049,2.063,.715l1.051,2.164c.408,.841,1.303,1.341,2.231,1.227,.573-.07,1.153-.105,1.736-.103,.932,.003,1.759-.602,2.064-1.483l.787-2.272c.278-.802,1.162-1.232,1.964-.954l2.955,1.023c.802,.278,1.231,1.162,.954,1.964l-.787,2.272c-.305,.881-.03,1.867,.705,2.442,.46,.36,.894,.746,1.301,1.155,.659,.663,1.671,.824,2.512,.415l2.164-1.051c.764-.371,1.692-.049,2.063,.715l1.366,2.813c.371,.764,.049,1.692-.715,2.063l-2.164,1.051c-.841,.408-1.341,1.303-1.227,2.231,.07,.573,.105,1.153,.103,1.736-.003,.933,.602,1.759,1.483,2.064l2.272,.787c.802,.278,1.232,1.162,.954,1.964l-1.023,2.955c-.278,.802-1.162,1.231-1.964,.954Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-99fe3349-183b-4506-bcfb-4b2cd852dc28",
    d: "M171.933,99.369c1.688-4.875-.895-10.195-5.77-11.884-4.875-1.688-10.195,.895-11.884,5.77-1.688,4.875,.895,10.195,5.77,11.884,4.875,1.688,10.195-.895,11.884-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7430ef9f-229e-49e4-96ce-85e3ed852d9a",
    d: "M166.881,97.619c.722-2.085-.383-4.36-2.467-5.082-2.085-.722-4.36,.383-5.082,2.467-.722,2.085,.383,4.36,2.467,5.082,2.085,.722,4.36-.383,5.082-2.467Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "uuid-b00b85fd-e06c-44be-bc40-edc7a6d5b4be",
    "data-name": "Layer 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsheet);
export default __webpack_public_path__ + "static/media/jobsheet.65bee815fc651809449e38ec7a6f6671.svg";
export { ForwardRef as ReactComponent };